'use client';

import {AppRouterCacheProvider} from '@mui/material-nextjs/v14-appRouter';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider as MuiThemeProvider} from '@mui/material/styles';
import {FC, PropsWithChildren} from 'react';
import theme from './_theme';

export const ThemeProvider: FC<PropsWithChildren> = ({children}) => {
    return (
        <AppRouterCacheProvider
            options={{
                key: 'mui',
                enableCssLayer: true,
            }}
        >
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </MuiThemeProvider>
        </AppRouterCacheProvider>
    );
};
